import { BookOpen, Clipboard, ClipboardList, Database, Download, FileText, Globe, GraduationCap, Heart, HeartHandshake, IndianRupee, Layout, Link, MessageCircle, Search, Share2, Trophy, Users, Video } from "lucide-react";
import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";

const aiFeatures = [
  {
    tinyTitle: "AI Marketing Team",
    team: "AI Marketing Team",
    icon: <Layout className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Instant Website Developer",
    description: "Launch your complete school website in under 10 minutes — fully mobile-friendly and SEO-ready."
  },
  {
    tinyTitle: "AI Marketing Team",
    team: "AI Marketing Team",
    icon: <Search className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "SEO Specialist",
    description: "Brings your school to the top of Google searches, increasing parent enquiries by 5X."
  },
  {
    tinyTitle: "AI Marketing Team",
    team: "AI Marketing Team",
    icon: <Share2 className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Social Media Manager",
    description: "Runs Facebook, Instagram, and YouTube automatically — posting updates that boost visibility by 10X."
  },
  {
    tinyTitle: "AI Marketing Team",
    team: "AI Marketing Team",
    icon: <Video className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Automated Reels & Videos Maker",
    description: "Creates daily motivational and admission-focused reels that reach 1lakh+ parents every month."
  },
  {
    tinyTitle: "AI Marketing Team",
    team: "AI Marketing Team",
    icon: <Users className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "24/7 Virtual Admissions Counsellor",
    description: "Chats with parents, answers FAQs, and converts enquiries — boosting admission revenue by 2.5 crore/yr."
  },
  {
    tinyTitle: "AI Teaching Team",
    team: "AI Teaching Team",
    icon: <GraduationCap className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "SuperStudent",
    description: "Daily learning challenges that improve student performance vs other schools."
  },
  {
    tinyTitle: "AI Teaching Team",
    team: "AI Teaching Team",
    icon: <Trophy className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "1st Rank",
    description: "Personal AI tutor that raises class results and keeps every child on track."
  },
  {
    tinyTitle: "AI Teaching Team",
    team: "AI Teaching Team",
    icon: <Heart className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "AI Parent Helpdesk",
    description: "24/7 guidance to parents on progress, behaviour, and learning habits — boosting satisfaction."
  },
  {
    tinyTitle: "AI Teaching Team",
    team: "AI Teaching Team",
    icon: <BookOpen className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "AI Child Care",
    description: "Sends emotional wellbeing podcasts & childcare guidance — 44+ topics already covered and more added regularly."
  },
  {
    tinyTitle: "AI Operations Team",
    team: "AI Operations Team",
    icon: <IndianRupee className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Auto Fee Collection",
    description: "Automates reminders & tracking — improving collection efficiency by 98% and reducing late payments."
  },
  {
    tinyTitle: "AI Operations Team",
    team: "AI Operations Team",
    icon: <Globe className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Multilingual Communication",
    description: "Updates in 10+ Indian languages via IVR, SMS, WhatsApp & app notifications — ensuring 100% understanding."
  },
  {
    tinyTitle: "AI Operations Team",
    team: "AI Operations Team",
    icon: <Clipboard className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Parental Feedback",
    description: "Collects & analyses feedback automatically — improving ratings and satisfaction."
  },
  {
    tinyTitle: "AI Operations Team",
    team: "AI Operations Team",
    icon: <ClipboardList className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Homework Assist",
    description: "Tracks & updates homework automatically — saving 4,400+ teacher hours/yr (₹8 lakh recovered in salaries)."
  },
  {
    tinyTitle: "AI Support Team",
    team: "AI Support Team",
    icon: <HeartHandshake className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Self Healer",
    description: "Detects & fixes technical issues automatically — ensuring zero downtime."
  },
  {
    tinyTitle: "AI Support Team",
    team: "AI Support Team",
    icon: <FileText className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Record & Report",
    description: "Record and share issues instantly — one-click screen + voice capture."
  },
  {
    tinyTitle: "AI Support Team",
    team: "AI Support Team",
    icon: <Users className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Virtual Relationship Manager",
    description: "Onboards your school in under 1 minute and provides a dedicated virtual assistant for support."
  },
  {
    tinyTitle: "AI Support Team",
    team: "AI Support Team",
    icon: <MessageCircle className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "AI Chat Bot",
    description: "Instant click-based insights for staff & parents — reducing support calls."
  },
  {
    tinyTitle: "AI Support Team",
    team: "AI Support Team",
    icon: <Download className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "AI App Downloader",
    description: "Ensures 100% parent app downloads in one month via WhatsApp & SMS campaigns — cutting extra marketing costs."
  },
  {
    tinyTitle: "AI Support Team",
    team: "AI Support Team",
    icon: <Link className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "AI Social Media Connector",
    description: "Links your social platforms with your website automatically — improving visibility & instant updates."
  },
  {
    tinyTitle: "AI Support Team",
    team: "AI Support Team",
    icon: <Database className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "AI Data Migration",
    description: "Transfers old student, fee & parent data safely in under 3 minutes."
  }
];

export default function AiExpertDirectBenifits() {

    return (
        <Box
            badge={"Complete 24×7 AI Workforce"}
            title={"AI Expert Team & Direct Benefits"}
            leftBlock={
                <div className='col-span-2 md:col-span-1'>
                    <div className="grid grid-cols-3 md:grid-cols-1 gap-6">
                        {aiFeatures.map((member, index) => <MarktingCard key={"memberasdsadInnerCard" + index} member={member} />)}
                    </div>
                </div>
            }
        />
    );
}